export const API_ENDPOINTS = {

  DASHBOARD: {
    GET_DATA: '/admin/dashboard',
  },

  GAME_ROOMS: {
    GET_ALL: '/admin/game-rooms',
    GET_ONE: (id: string) => `/admin/game-rooms/${id}`,
    CREATE: '/admin/game-rooms',
    UPDATE: (id: string) => `/admin/game-rooms/${id}`,
    TOGGLE_ACTIVE: (id: string) => `/admin/game-rooms/${id}/toggle-active`,
  },

  USERS: {
    GET_ALL: '/admin/users',
    GET_ONE: (id: string) => `/admin/users/${id}`,
    TOGGLE_ACTIVE: (id: string) => `/admin/users/${id}/toggle-active`,
      UPDATE_BALANCE: (id: string) => `/admin/users/${id}/balance`,
      GET_GAMES: (id: string) => `/admin/users/${id}/games`,

  },

  CREDITS: {
    STATS: '/admin/credits/stats',
    GET_ALL: '/admin/credits',
    GET_ONE: (id: string) => `/admin/credits/${id}`,
    CREATE: '/admin/credits',
    SEARCH_USERS: '/admin/credits/users/search',
    RECEIVER_NAMES: '/admin/credits/receiver-names',
  },
   // ...existing
  WITHDRAWALS: {
    STATS: '/admin/withdrawals/stats',
    GET_ALL: '/admin/withdrawals',
    GET_ONE: (id: string) => `/admin/withdrawals/${id}`,
    CREATE: '/admin/withdrawals',
    ACCEPT: (id: string) => `/admin/withdrawals/${id}/accept`,
    MARK_PAID: (id: string) => `/admin/withdrawals/${id}/mark-paid`,
    REJECT: (id: string) => `/admin/withdrawals/${id}/reject`,
    SEARCH_USERS: '/admin/withdrawals/users/search',
  },
    FINANCIAL: {
    GET_ALL: '/admin/financial',
    GET_ONE: (id: string) => `/admin/financial/${id}`,
    CREATE: '/admin/financial',
    GET_STATS: '/admin/financial/stats',
  },
    PLATFORM_SETTINGS: {
    GET: '/admin/platform-settings',
    UPDATE: '/admin/platform-settings',
    RESET: '/admin/platform-settings/reset',
  },
  POST: {
  GET_ROOMS: '/admin/post/rooms',
  SEND_BROADCAST: '/admin/post/broadcast',
},
BANKS: {
  GET_ALL: '/admin/banks',
  GET_ONE: (id: string) => `/admin/banks/${id}`,
  CREATE: '/admin/banks',
  UPDATE: (id: string) => `/admin/banks/${id}`,
  DELETE: (id: string) => `/admin/banks/${id}`,
  TOGGLE_ACTIVE: (id: string) => `/admin/banks/${id}/toggle-active`,
},
AUTH: {
  LOGIN: '/admin/auth/login',
  LOGOUT: '/admin/auth/logout',
  ME: '/admin/auth/me',
  REFRESH_TOKEN: '/admin/auth/refresh-token',
  CHANGE_PASSWORD: '/admin/auth/change-password',
  UPDATE_PROFILE: '/admin/auth/me',
},
ADMINS: {
  GET_ALL: '/admin/admins',
  GET_ONE: (id: string) => `/admin/admins/${id}`,
  CREATE: '/admin/admins',
  UPDATE: (id: string) => `/admin/admins/${id}`,
  TOGGLE_STATUS: (id: string) => `/admin/admins/${id}/toggle-status`,
  DELETE: (id: string) => `/admin/admins/${id}`,
},
  GAME_HISTORY: {
    GET_ALL: '/admin/game-history',
    GET_ONE: (id: string) => `/admin/game-history/${id}`,
  },
    SPIN: {
    /* Prizes */
    GET_PRIZES: '/admin/spin/prizes',
    GET_PRIZE: (id: string) => `/admin/spin/prizes/${id}`,
    CREATE_PRIZE: '/admin/spin/prizes',
    UPDATE_PRIZE: (id: string) => `/admin/spin/prizes/${id}`,
    TOGGLE_PRIZE_ACTIVE: (id: string) =>
      `/admin/spin/prizes/${id}/toggle-active`,
    DELETE_PRIZE: (id: string) => `/admin/spin/prizes/${id}`,

    /* Wins */
    GET_WINS: '/admin/spin/wins',
    GET_WIN: (id: string) => `/admin/spin/wins/${id}`,
    GET_WIN_STATS: '/admin/spin/wins/stats',
    UPDATE_WIN_STATUS: (id: string) => `/admin/spin/wins/${id}/status`,
  },
    HOUSE_PLAYERS: {
    LIST: '/admin/house-players',
    STATS: '/admin/house-players/stats',
    SETTINGS: '/admin/house-players/settings',
     ROOMS: '/admin/house-players/rooms',
    CREATE: '/admin/house-players',
    DETAIL: (id: string) => `/admin/house-players/${id}`,
    UPDATE: (id: string) => `/admin/house-players/${id}`,
    TOGGLE: (id: string) => `/admin/house-players/${id}/toggle-retired`,
    DELETE: (id: string) => `/admin/house-players/${id}`,
  },
  RECONCILIATION: {
    GET: '/admin/reconciliation',
  },
    REFERRALS: {
    LIST: '/admin/referrals',
    STATS: '/admin/referrals/stats',
    DETAIL: (id: string) => `/admin/referrals/${id}`,
    CREATE_AGENT: '/admin/referrals/agents',
    UPDATE: (id: string) => `/admin/referrals/${id}`,
    DEMOTE: (id: string) => `/admin/referrals/${id}/demote`,
    TOGGLE_ENABLED: (id: string) => `/admin/referrals/${id}/toggle-enabled`,
  },
    TRANSFERS: {
    GET_ALL: '/admin/transfers',
    GET_ONE: (id: string) => `/admin/transfers/${id}`,
  },
   USER_WIN_CHECK: {
    FIND_USER: '/admin/user-win-check/find-user',
    USER_GAME: (telegramId: string, gameId: string) =>
      `/admin/user-win-check/users/${telegramId}/games/${gameId}`,
  },
};
